import React from 'react';
import AddressForm from './AddressForm'
import Typography from '@material-ui/core/Typography';

function BillingAddress(props) {
  const {data, actions, showErrors} = props

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Billing Address
      </Typography>
      <AddressForm
        showErrors={showErrors}
        address={data.billingAddress}
        onSave={actions.updateBillingAddress}
      />
    </React.Fragment>
  );
}

export default BillingAddress;